<div class="location-switcher">
  <!-- Current Location Display -->
  <div class="current-location mb-3">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-map-marker text-primary"></i>
      <div>
        <div class="text-sm text-color-secondary">Current Location</div>
        <div class="font-semibold">{{ getCurrentLocationDisplay() }}</div>
      </div>
    </div>
  </div>

  <!-- Location Search -->
  <div class="location-search mb-3">
    <label class="block text-sm font-medium text-color-secondary mb-2">
      Switch Location
    </label>
    <p-autoComplete 
      [(ngModel)]="selectedLocation"
      [suggestions]="filteredLocations"
      (completeMethod)="onLocationSearch($event)"
      (onSelect)="onLocationSelected($event.value)"
      field="name"
      placeholder="Search locations..."
      [dropdown]="true"
      [showEmptyMessage]="true"
      emptyMessage="No locations found"
      styleClass="w-full"
      inputStyleClass="w-full"
      [disabled]="isLoading"
      [minLength]="0"
      [delay]="0">
      
      <!-- Custom template for dropdown items -->
      <ng-template let-location pTemplate="item">
        <div class="flex align-items-center gap-2 p-2">
          <i class="pi pi-building text-color-secondary"></i>
          <div>
            <div class="font-semibold">{{ location.name }}</div>
            <!-- <div class="text-sm text-color-secondary">ID: {{ location.id }}</div> -->
          </div>
        </div>
      </ng-template>
    </p-autoComplete>
  </div>

  <!-- Recent Locations -->
  <div class="recent-locations" *ngIf="recentLocations.length > 0">
    <div class="flex align-items-center justify-content-between mb-2">
      <label class="text-sm font-medium text-color-secondary">
        Recent Locations
      </label>
      <p-button icon="pi pi-refresh" [text]="true" [rounded]="true" size="small" (onClick)="onRefresh()"
        [disabled]="isLoading" pTooltip="Refresh locations">
      </p-button>
    </div>
  
    <div class="grid gap-2">
      <div *ngFor="let recentLocation of recentLocations" class="col-12">
        <p-button [label]="recentLocation.name" [outlined]="!isCurrentLocation(recentLocation)"
          [disabled]="isLoading || isCurrentLocation(recentLocation)" size="small"
          styleClass="w-full justify-content-start text-left" (onClick)="onRecentLocationClick(recentLocation)"
          icon="pi pi-clock">
        </p-button>
      </div>
    </div>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="flex align-items-center justify-content-center p-3">
    <p-progressSpinner 
      styleClass="w-2rem h-2rem" 
      strokeWidth="4">
    </p-progressSpinner>
    <span class="ml-2 text-sm text-color-secondary">Switching location...</span>
  </div>

  <!-- Empty state when no recent locations -->
  <div 
    *ngIf="recentLocations.length === 0 && !isLoading" 
    class="text-center p-3 text-color-secondary">
    <i class="pi pi-info-circle mb-2 text-2xl"></i>
    <div class="text-sm">
      No recent locations. Use the search above to find and switch to a location.
    </div>
  </div>
</div>